import { render } from "./HeadingDataTableComponent.vue?vue&type=template&id=44692e28&scoped=true"
import script from "./HeadingDataTableComponent.vue?vue&type=script&lang=js"
export * from "./HeadingDataTableComponent.vue?vue&type=script&lang=js"

import "./HeadingDataTableComponent.vue?vue&type=style&index=0&id=44692e28&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-44692e28"]])

export default __exports__